import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';


export const LanguagesContainer = styled.div<{open:boolean}>`
  display: ${props => props.open?"block":"none"};
  position: absolute;
  top:32px;
  right:0;
  padding-top:10px;
`;

export const LanguageContainer = styled.div<{open:boolean, top?:string, right?:string, background?:string}>`
  background: ${props => props.background?(props.open?"#e2e2e2":props.background):(props.open?"#ff6c6c":"#fa8383")};
  position: absolute;
  top: ${props => props.top?"35px":"28px"} ;
  right: ${props => props.right?"50px":"90px"} ;
  border-radius:4px;
  height:32px;
  z-index: 4;
  transition: background 0.2s ease-in-out;
  box-shadow: ${props => props.background?"0 0 2px 1px rgba(0,0,0,0.25)":"unset"} ;

  
  :hover{
    background:${props => props.background?"#e2e2e2":"#ff6c6c"};
  }

  div > svg:last-of-type{
    path{
      fill: ${props => props.background?"#000":"#fff"} ;
    }
  }

  ${mq(Devices.laptop)} {
    top: ${props => props.top?"35px":"28px"} ;
    right: ${props => props.right?"50px":"90px"} ;
  }

  ${mq(Devices.tablet)} {
    top: ${props => props.top?props.top:"28px"} ;
    right: ${props => props.right?props.right:"90px"} ;
  }

  ${mq(Devices.mobile)} {
    top: ${props => props.top?props.top:"28px"} ;
    right: ${props => props.right?props.right:"90px"} ;
  }
`;


export const SelectedLanguage = styled.div`
  display:flex;
  height:100%;
  padding:0 10px;
  align-items: center;
  cursor: pointer;

  svg:first-of-type{
    width:30px;
  }
  svg:last-of-type{
    width:16px;
    margin-left: 10px;
    path{
      fill:#fff;
    }
  }

  
`;



export const LanguagesSelector = styled.div`
  display:flex;
  flex-direction: column;
  background:#fff;
  box-shadow: 0 0 4px 1px rgba(0,0,0,0.15);
  border-radius:4px;
  padding:8px 0;
  min-width: 150px;
`;


export const Language = styled.button<{ current?: boolean }>`
 
  background: ${props => props.current?"rgba(71,199,239, 0.25)":"transparent"};
  transition:opacity 0.2s ease-in-out;
  padding:6px 10px;
  display:flex;
  align-items: center;

  :hover{
    background:${props => props.current?"rgba(71,199,239, 0.25)":"rgba(71,199,239, 0.17)"};
  }
  svg{
    width:26px;
    margin-right: 12px;
  }
  span{
    font-size:16px;
    font-weight: 500;
  }
`;
